<template>
  <transition name="fade">
    <div class="update" v-if="show" role="status">
      <span class="update__dot"></span>
      <span class="update__text">A new version of the scanner is ready.</span>
      <button class="update__btn" @click="reload">Reload now</button>
      <button class="update__later" @click="show = false" aria-label="Dismiss">Later</button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'UpdateBanner',
  data(){
    return {
      show: false,
      registration: null
    }
  },
  mounted(){
    document.addEventListener('swUpdated', this.onUpdated)
  },
  beforeUnmount(){
    document.removeEventListener('swUpdated', this.onUpdated)
  },
  methods:{
    onUpdated(e){
      this.registration = e.detail
      this.show = true
    },
    reload(){
      // service-worker.js calls skipWaiting(), so the new worker is already
      // active -- a plain reload picks up the new precached index.html.
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.update{
  position:fixed;
  top:0;
  left:0;
  right:0;
  z-index:2000;
  display:flex;
  align-items:center;
  gap:.75rem;
  padding:.7rem 1rem;
  background:var(--surface-inverse);
  color:var(--text-inverse);
  font-size:.88rem;
  font-weight:600;
  box-shadow:var(--shadow-md);
}

.update__dot{
  width:8px;
  height:8px;
  border-radius:50%;
  background:var(--success);
  flex:none;
}

.update__text{
  margin-right:auto;
}

.update__btn{
  min-height:38px;
  padding:0 1rem;
  border:none;
  border-radius:var(--r-sm);
  background:#fff;
  color:var(--surface-inverse);
  font-size:.85rem;
  font-weight:700;
  cursor:pointer;
}

.update__later{
  min-height:38px;
  padding:0 .6rem;
  border:none;
  background:transparent;
  color:rgba(255,255,255,.7);
  font-size:.85rem;
  font-weight:600;
  cursor:pointer;
}

@media (max-width:560px){
  .update{ font-size:.82rem; gap:.5rem; }
  .update__text{ line-height:1.3; }
}
</style>
